import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationAssetGroupInventory = createCrudVuexModule({
  namespaced: true,
  path: "/asset-group-inventory",

  state: { isDownloading: false },
  getters: { isDownloading: (state) => state.isDownloading },
  mutations: { isDownloading: (state, value) => (state.isDownloading = value) },
  actions: {
    async updateAssetGroupCount({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/asset-group-inventory/asset-group-count`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateAssetGroupDescription({ commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.put(`/asset-group-inventory/asset-group-description`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/asset-group-inventory/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});
